// extracted by mini-css-extract-plugin
export default {"hexagons":"hexagons__BxnepD","langSelect":"langSelect__kHGFih"};